const TrackOrder = () => import(/* webpackChunkName: "track-order" */ './TrackOrder');

export default {
  path: '/track-order',
  component: TrackOrder,
  name: 'trackOrder',
};